export function scorePassword(pwd) {
  if (!pwd) return { score: 0, label: "—", color: "bg-slate-700", pct: 0 };
  let s = 0;
  if (pwd.length >= 6) s++;
  if (pwd.length >= 10) s++;
  if (/[A-Z]/.test(pwd) && /[a-z]/.test(pwd)) s++;
  if (/\d/.test(pwd)) s++;
  if (/[^A-Za-z0-9]/.test(pwd)) s++;
  const map = [
    { label: "Très faible", color: "bg-red-500", pct: 15 },
    { label: "Faible", color: "bg-red-400", pct: 30 },
    { label: "Moyen", color: "bg-amber-400", pct: 55 },
    { label: "Bon", color: "bg-emerald-500", pct: 80 },
    { label: "Fort", color: "bg-emerald-400", pct: 100 },
    { label: "Excellent", color: "bg-emerald-300", pct: 100 },
  ];
  return { score: s, ...map[Math.min(s, 5)] };
}

export default function PasswordStrength({ value }) {
  const { label, color, pct } = scorePassword(value);
  if (!value) return null;
  return (
    <div data-testid="pw-strength" className="mt-1">
      <div className="h-1.5 w-full rounded-full bg-slate-800 overflow-hidden">
        <div className={`h-full ${color} transition-all duration-300`} style={{ width: `${pct}%` }} />
      </div>
      <div className="mt-1 flex items-center justify-between text-[10px] text-slate-400">
        <span>Force : <span className="text-slate-200">{label}</span></span>
        <span className="text-slate-500">min 6 · +majuscule +chiffre +caractère spécial</span>
      </div>
    </div>
  );
}
